/*
 * @Author: your name
 * @Date: 2021-05-28 20:18:01
 * @LastEditTime: 2025-09-19 15:49:18
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\api\request.js
 */

// import axios from 'axios';
import axios from 'more-request/instance';

import VueCookies from 'vue-cookies';
import { Message } from 'element-ui';
import router from '../router/router.js';
import utils from '../utils/utils';
import store from '../store/index';
import { gateway, epecGrayGroup, secure, processEnv } from './config';
// import epecAES from '../utils/EPECAES';

axios.defaults.timeout = 50000;
axios.defaults.baseURL = `${gateway}/api`;
axios.defaults.withCredentials = true;
let record403 = false;
axios.interceptors.request.use(
  (config) => {
    const token = VueCookies.get('epecToken');
    const { companyId } = store.state.USERINFO;
    if (config.url.indexOf('/user-center/user/mallLoginOut') != -1) {
      // alert(123)
      VueCookies.remove('epecUrlToRedirectAfterLogout', {
        domain: '.epec.com',
        path: '/',
        secure,
      });
    }

    const isOssurl = config.url.indexOf('.json') != -1;
    if (token && !isOssurl) {
      if (companyId) {
        config.headers = {
          'Content-Type': 'application/json',
          'epec-sso-token': token,
          'epec-from': 'CORP_WEB_SITE',
          // 'epec-from': 'PURCHASE_WEB_SITE',
          'epec-locale': 'ZH',
          'epec-company-id': companyId,
        };
      } else {
        config.headers = {
          'Content-Type': 'application/json',
          'epec-sso-token': token,
          'epec-from': 'CORP_WEB_SITE',
          // 'epec-from': 'PURCHASE_WEB_SITE',
          'epec-locale': 'ZH',
        };
      }
    } else {
      // axios.defaults.withCredentials = false;
      config.headers = {
        'Content-Type': 'application/json',
      };
    }
    if (process.env.NODE_ENV !== 'production') {
      VueCookies.set(
        'epec-gray-group',
        epecGrayGroup,
        null,
        '/',
        '.epec.com',
        secure
      );
      config.headers['epec-gray-group'] = epecGrayGroup;
    }

    // 入参加密：调用方在 axios config 中显式声明 needEncrypt 时启用
    // 载荷形态与 epec-mall 一致：{ data: epecAES.encrypt(JSON.stringify(原值)) }
    if (config.needDecrypt === true) {
      const isPost =
        typeof config.method === 'string' &&
        config.method.toLowerCase() === 'post';
      const target = isPost ? config.data : config.params;
      const isNonEmptyObject =
        target &&
        typeof target === 'object' &&
        !(target instanceof FormData) &&
        Object.keys(target).length > 0;
      if (isNonEmptyObject) {
        const cipher = window._TAC.encryptParams({
          ...target,
          env:processEnv
        })
        if (isPost) {
          config.data = cipher;
        } else {
          config.params = cipher;
        }
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
); // 响应拦截器即异常处理
axios.interceptors.response.use(
  (response) => {
    if (response.data && response.data.freshToken) {
      VueCookies.set(
        'epecToken',
        response.data.freshToken,
        null,
        '/',
        '.epec.com',
        secure
      );
      const seconds =
        new Date().getTime() + response.data.freshTokenMaxAgeToAdd * 1000;
      VueCookies.set(
        'epecTokenExpiredTime',
        seconds,
        null,
        '/',
        '.epec.com',
        secure
      );
    }

    // 份额控制 10秒提示
    const urlArr = [
      '/purchase/purchaseShare/add',
      '/purchase/purchaseShare/batchAdd',
      '/purchase/purchaseShare/modify',
    ];

    // 出参解密：调用方在 axios config 中显式声明 needDecrypt 时启用
    // Blob / 非 200 响应跳过；解密或 JSON.parse 失败仅 console.warn 不抛错
    if (
      response.config &&
      response.config.needDecrypt === true &&
      utils.getDataType(response.data) !== 'Blob' 
    ) {
      try {
      //  console.log(response.data.data.data, 'response.data.data')
      // //  console.log(processEnv, 'processEnv')
      // //  console.log(window._TAC, 'window._TAC')
      // console.log(response.data.data.data, 'response.data.data.data')
        const plain = window._TAC.handleDecrypt(response.data.data.data,processEnv);
        // console.log(plain, 'plain')
        if (plain) {
          // console.log(plain, 'plain')
          response.data.data = JSON.parse(plain.data);
        } else {
          console.warn(
            '[request] decrypt returned empty for url:',
            response.config.url
          );
        }
      } catch (e) {
        console.warn(
          '[request] decrypt/JSON.parse failed for url:',
          response.config.url,
          e
        );
      }
    }

    if (
      utils.getDataType(response.data) !== 'Blob' &&
      response.data.code &&
      response.config.url !==
      '/standard/evaluation/evaluationApply/checkEvaluationApplyCondition'
    ) {
      const codeArr = ['200', 'SAME_IP_ADDRESS'];
      if (!codeArr.includes(String(response.data.code))) {
        Message.closeAll();

        if (urlArr.includes(response.config.url)) {
          Message({
            message: response.data.message
              ? response.data.message
              : '服务器异常错误！',
            type: 'error',
            duration: 10000, // 10秒后自动关闭
          });
        } else {
          Message({
            message: response.data.message
              ? response.data.message
              : '服务器异常错误！',
            type: 'error',
          });
        }
      }
    }
    return response;
  },
  (err) => {
    // 每次手动关闭所有弹框
    Message.closeAll();
    if (err.response.status == 401) {
      // Message({
      //   message: "抱歉，你没有访问权限",
      //   type: "error",
      // });
      router.push({ path: '/ssologin' });
    }
    if (err.response.status == 403) {
      Message({
        message: '您没有权限访问该页面，请联系管理员分配权限',
        type: 'error',
      });
      if (!record403) {
        router.push({ path: '/403' });
      }
      // alert(record403)
      record403 = true;
      // router.push({ path: '/403' });
    }
    return Promise.resolve(err.response);
  }
);
const request = {
  /**
   * 封装get方法
   * @param url
   * @param data
   * @returns {Promise}
   */
  fetch(url, params = {}, config = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(url, {
          // qmJson: JSON.stringify(params)
          params,
          ...config,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  /**
   * 封装post请求
   * @param url
   * @param data
   * @returns {Promise}
   */
  post(url, data = {}, otherConfig = {}) {
    return new Promise((resolve, reject) => {
      axios
        .post(url, data, { ...otherConfig })
        // axios.post(url, Qs.stringify(data))
        .then(
          (response) => {
            resolve(response.data);
          },
          (err) => {
            reject(err);
          }
        );
    });
  },
  // 获取基础地址
  getBaseUrl() {
    return axios.defaults.baseURL;
  },
};
export default request;
